import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { DasboardService } from "../../Services/DashboardService";

Modal.setAppElement("#root");

const ProgressBar = () => {
  const [bars, setBars] = useState([]);
  const [barsALL, setBarsALL] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalSquare, setTotalSquare] = useState([]);

  const registeredPlot = "ylDevuPUDBzdGXM44j1P";

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await DasboardService.getTopSellingProperty(registeredPlot)
        const data = response.data;
        console.log(data);
        setTotalSquare(data.totalSquareFeet);

        // const formattedBars = data.map((property) => ({
        //   name: property.propertyName,
        //   progress:
        //     (property.totalRegisteredSquareFeet / property.totalSquareFeet) *
        //       100 || 0,
        //   progressValue: `${Math.round(
        //     (property.totalRegisteredSquareFeet / property.totalSquareFeet) *
        //       100
        //   )}%`,
        //   progressSquareFeet: `${property.totalSquareFeet.toLocaleString()} Sqft`,
        //   registeredSquareFeet: `${property.totalRegisteredSquareFeet.toLocaleString()} Sqft`, // For tooltip
        // }));

        const formattedBars = data.map((property) => {
          const progress =
            (property.totalRegisteredSquareFeet / property.totalSquareFeet) *
              100 || 0;

          return {
            name: property.propertyName,
            progress,
            progressValue: isNaN(progress) ? "0%" : `${Math.round(progress)}%`,
            progressSquareFeet: `${property.totalSquareFeet.toLocaleString()} Sqft`,
            registeredSquareFeet: `${property.totalRegisteredSquareFeet.toLocaleString()} Sqft`,
          };
        });

        formattedBars.sort((a, b) => b.progress - a.progress);
        const top5Bars = formattedBars.slice(0, 5);
        const top = formattedBars;
        const topColor = "#399E79";
        const defaultColor = "#EE6C4D";

        const barsWithColor = top5Bars.map((bar, index) => ({
          ...bar,
          color: index === 0 ? topColor : defaultColor,
        }));
        const barsWithAll = top.map((bar, index) => ({
          ...bar,
          color: index === 0 ? topColor : defaultColor,
        }));

        setBars(barsWithColor);
        setBarsALL(barsWithAll);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [registeredPlot]);

  function getNumericValue(progressSquareFeet) {
    const numericValue = parseFloat(progressSquareFeet.replace(/[^0-9.]/g, ""));
    return numericValue || 0;
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "45%",
      overflow: "hidden",
      padding: "30px",
      position: "relative",
      backgroundColor: "white",
    },
    overlay: {
      zIndex: 10000,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };

  function formatNumber(num) {
    if (num >= 1e7) {
      return (num / 1e7).toFixed(1).replace(/\.0$/, "") + "C";
    }
    if (num >= 1e5) {
      return (num / 1e5).toFixed(1).replace(/\.0$/, "") + "L";
    }
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1e3) {
      return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return num.toString();
  }

  return (
    <div className="container xl:h-[350px] w-full  3xl:h-[440px]  4xl:h-[520px] shadow-md rounded-lg p-5 mx-0 bg-white">
      {bars.length > 4 ? (
        <a
          className="text-blue-500 cursor-pointer  float-right"
          onClick={handleOpenModal}
        >
          View More
        </a>
      ) : (
        <div></div>
      )}
      <div className="flex justify-between mt-5 w-full">
        <h1 className="text-left text-xl font-semibold mb-3 xl:text-lg custom-xl:text-xl 3xl:text-2xl 4xl:text-3xl">
          Top Selling Property
        </h1>
        <h1 className="font-semibold mr-5 text-lg float-right">Total Sqft</h1>
      </div>

      <div className="flex flex-col gap-1 3xl:gap-5 xl:text-xs pb-4">
        {bars.length > 0 ? (
          bars.map((bar, index) => (
            <div key={index}>
              <p className="text-lg font-normal xl:text-lg custom-xl:text-xl 3xl:text-xl 4xl:text-2xl">
                {bar.name}
              </p>
              <div className="flex items-center">
                {/* Progress Bar with Tooltip */}
                <div className="relative w-full bg-gray-200 h-2.5 rounded-full mr-8 group">
                  <div
                    className="h-full rounded-full"
                    style={{
                      width: `${bar.progress}%`,
                      backgroundColor: bar.color,
                    }}
                  ></div>

                  {/* Tooltip */}
                  <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg">
                    {/* <p>Total: {bar.progressSquareFeet}</p> */}
                    <p>Registered: {bar.registeredSquareFeet}</p>
                  </div>
                </div>
                <p className="mr-10 xl:font-bold custom-xl:font-bold 3xl:font-bold 3xl:text-sm 4xl:font-bold 4xl:text-xl">
                  {bar.progressValue}
                </p>
                <p className="w-44 xl:font-bold custom-xl:font-bold 3xl:font-bold 3xl:text-sm 4xl:font-bold 4xl:text-xl">
                  {formatNumber(getNumericValue(bar.progressSquareFeet))}{" "}
                  <span className="ml-2"> Sq Feet</span>
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-red-500 text-center text-2xl mt-20">
            There is no Top-selling property
          </p>
        )}
      </div>

      {/* Modal for viewing more details */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Create Team"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>
        <div className="flex justify-between">
          <h1 className="text-left text-xl font-semibold mb-3 xl:text-lg custom-xl:text-xl 3xl:text-2xl 4xl:text-3xl">
            Top Selling Property
          </h1>
          <h1 className="font-semibold mr-10 text-lg">Total Sqft</h1>
        </div>
        <div className="flex flex-col gap-1 3xl:gap-5 xl:text-xs pb-4 overflow-y-auto max-h-[90%] custom-scrollbar">
          {barsALL.length > 0 ? (
            barsALL.map((bar, index) => (
              <div key={index}>
                <p className="text-lg font-normal xl:text-lg custom-xl:text-xl 3xl:text-xl 4xl:text-2xl">
                  {bar.name}
                </p>
                <div className="flex items-center">
                  <div className="relative w-full bg-gray-200 h-2.5 rounded-full mr-8 group">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${bar.progress}%`,
                        backgroundColor: bar.color,
                      }}
                    ></div>
                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg">
                      {/* <p>Total: {bar.progressSquareFeet}</p> */}
                      <p>Registered: {bar.registeredSquareFeet}</p>
                    </div>
                  </div>
                  <p className="mr-10 xl:font-bold custom-xl:font-bold 3xl:font-bold 3xl:text-sm 4xl:font-bold 4xl:text-xl">
                    {bar.progressValue}
                  </p>
                  <p className="w-44 xl:font-bold custom-xl:font-bold 3xl:font-bold 3xl:text-sm 4xl:font-bold 4xl:text-xl">
                    {formatNumber(getNumericValue(bar.progressSquareFeet))}{" "}
                    <span className="ml-2"> Sq Feet</span>
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-red-500 text-center text-2xl mt-20">
              There is no Top-selling property
            </p>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ProgressBar;
